import { Injectable } from '@angular/core';
import { FeatureConfigFacade } from '@common/data-access-feature-config';
import {
  ApplianceDetailsFormDataProvider,
  ApplianceFormSubmit,
  ParseResponse,
  ParseResult,
} from '@common/util-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ApplianceDetailsStoreFeatureConfigFormDataProvider
  implements ApplianceDetailsFormDataProvider
{
  priority = 1;
  constructor(private featureConfigFacade: FeatureConfigFacade) {}

  getApplianceDetailsForm(): Observable<ParseResponse<ApplianceFormSubmit>> {
    return this.featureConfigFacade.applianceDetails$.pipe(
      map((applianceDetailsConfig) => {
        if (!applianceDetailsConfig?.applianceDetailsFormData) {
          return { result: ParseResult.NotApplied };
        }

        const formData = applianceDetailsConfig.applianceDetailsFormData;
        const currentYear = new Date().getFullYear();
        const maxAge = 8;
        const minAllowedYear = currentYear - maxAge;

        const adjustedFormData = {
          ...formData,
          monthYearDate: formData.monthYearDate
            ? {
                ...formData.monthYearDate,
                year:
                  formData.monthYearDate.year < minAllowedYear
                    ? minAllowedYear
                    : formData.monthYearDate.year,
              }
            : formData.monthYearDate,
        };

        return {
          result: ParseResult.Success,
          model: adjustedFormData,
        };
      })
    );
  }
}
